import { FILTER_PARAM_NAMES, facetFor } from 'client-portal/utils/clinicianSearch/facets/manifest';
import { action } from '@ember/object';
import { buildClinicianSearchConsumerMeta } from 'client-portal/utils/clinicianSearch/consumer-meta';
import {
  controllerPropertyFor,
  toQueryParamKeys,
} from 'client-portal/utils/clinicianSearch/facets/query-param-aliases';
import { tracked } from '@glimmer/tracking';
import Service, { service } from '@ember/service';

export default class ClinicianSearchQueryService extends Service {
  @service router;
  @service clinicianSearch;

  @tracked pageNumber = 1;
  @tracked globalMonarchChannelId = null;
  @tracked name = null;
  @tracked availableDays = null;
  @tracked availableTimes = null;
  @tracked officeIds = null;
  @tracked cptCodes = null;
  @tracked specialty = null;
  @tracked insurance = null;
  @tracked treatmentType = null;
  @tracked approaches = null;
  @tracked ageGroup = null;
  @tracked availableNights = null;
  @tracked availableWeekends = null;
  @tracked inPerson = null;
  @tracked freeConsultation = null;

  resetState() {
    this.pageNumber = 1;
    this.globalMonarchChannelId = null;
    for (let param of FILTER_PARAM_NAMES) {
      this[controllerPropertyFor(param)] = null;
    }
  }

  buildConsumerMetaForClinicianSearch(rawMeta, options = {}) {
    return buildClinicianSearchConsumerMeta(rawMeta ?? {}, options);
  }

  toRouteParams() {
    return {
      pageNumber: this.pageNumber,
      globalMonarchChannelId: this.globalMonarchChannelId,
      ...Object.fromEntries(FILTER_PARAM_NAMES.map(n => [n, this[controllerPropertyFor(n)]])),
    };
  }

  @action
  applySearchFilter(queryParams = {}) {
    this.clinicianSearch.trackFilterChange(queryParams);
    let urlParams = toQueryParamKeys(queryParams);
    this.router.transitionTo({
      queryParams: {
        ...urlParams,
        pageNumber: urlParams.pageNumber ?? 1,
      },
    });
  }

  @action
  applyFacetFilter(facetKey, ...args) {
    let qp = facetFor(facetKey)?.apply?.(...args);
    if (qp) {
      this.applySearchFilter(qp);
    }
  }

  @action
  syncFromRouteParams(params = {}) {
    let urlParams = toQueryParamKeys(params);
    let n = parseInt(String(urlParams.pageNumber ?? 1), 10);
    this.pageNumber = Number.isNaN(n) || n < 1 ? 1 : n;
    this.globalMonarchChannelId = urlParams.globalMonarchChannelId ?? null;
    for (let param of FILTER_PARAM_NAMES) {
      this[controllerPropertyFor(param)] = urlParams[param] ?? null;
    }
  }
}
